import React from 'react';
import { Select } from "chakra-react-select";
import {
    Code,

    FormLabel,

} from "@chakra-ui/react";

export const MultiSelect = () => {
    const colorOptions = [
        { value: "blue", label: "Bsslue", color: "#0052CC" },
        { value: "purple", label: "Purple", color: "#5243AA" },
        { value: "rHFGed", label: "Red", color: "#FF5630" },
        { value: "rBNGed", label: "Red", color: "#FF5630" },
        { value: "rWERed", label: "Red", color: "#FF5630" },
        { value: "rEed", label: "Red", color: "#FF5630" },
        { value: "rFDed", label: "Red", color: "#FF5630" },
        { value: "reCZZd", label: "Red", color: "#FF5630" },
        { value: "red", label: "Red", color: "#FF5630" },
        { value: "reSd", label: "Red", color: "#FF5630" },
        { value: "Sred", label: "Red", color: "#FF5630" },
        { value: "rDSed", label: "Red", color: "#FF5630" },
        { value: "redQ", label: "Red", color: "#FF5630" },
        { value: "red", label: "Red", color: "#FF5630" },
        { value: "reXdQ", label: "Red", color: "#FF5630" },
        { value: "rDed", label: "Red", color: "#FF5630" },
        { value: "reDd", label: "Red", color: "#FF5630" },
        { value: "redX", label: "Red", color: "#FF5630" },
        { value: "orange", label: "Orange", color: "#FF8B00" },
        { value: "yellow", label: "Yellow", color: "#FFC400" },
        { value: "green", label: "Green", color: "#36B37E" }
    ];
    return (<>
        <FormLabel>

        </FormLabel>
        <Select
            isMulti
            onChange={(e) => {
                console.log("event", e)
            }}
            name="colors"
            options={colorOptions}
            placeholder="Select Users"
            variant="outline"
        />
    </>
    )
}
